"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessList = void 0;
class ProcessList {
}
exports.ProcessList = ProcessList;
//# sourceMappingURL=ProcessList.js.map